import React from 'react';
import '../../css/vers2/Footer.css';

const Footer = () => (
    <div className="site-footer">
        <span>L.R.K.nummer: 173 40 1375</span>
        <span>KvK nummer: 86046187</span>
    </div>
);

export default Footer;
